import { StyleSheet } from 'aphrodite';
import { alizarinCrimson, successGreen } from '../../styles/colors';

interface IndicatorStyleProps {
	isApproved: boolean;
	noMargin: boolean;
}

export const getIndicatorStyle = ({ isApproved, noMargin }: IndicatorStyleProps) => ({
	backgroundColor: isApproved ? 'rgba(15, 149, 151, 0.1)' : `rgba(222, 33, 57, 0.1)`,
	color: isApproved ? successGreen : alizarinCrimson,
	fontSize: 12,
	height: 26,
	padding: '0 8px',
	display: 'inline-flex',
	alignItems: 'center',
	borderRadius: 6,
	marginLeft: 0,
	width: 'fit-content',
	fontWeight: 400,
	marginBottom: noMargin ? 0 : 8,
});

export const iconStyle = {
	marginRight: 4,
	width: 16,
	height: 17,
};

export const styles = StyleSheet.create({
	indicator: {
		display: 'inline-flex',
		alignItems: 'center',
	},
});
